export const productEndpoints = {
  GET_PRODUCTS: '/account/products/detailed/',
  GET_PRODUCT: '/account/products/:productId/detailed/',
  GET_CATEGORIES: '/categories/detailed/',
  GET_ATTRIBUTE_SETS: '/attribute-sets/',
  GET_ATTRIBUTES: '/attributes/detailed/',
  GET_ATTRIBUTE_CONFIGS: '/attribute-configs/detailed/',
  GET_ATTRIBUTE_VALUES: '/attribute-values/',
  UPDATE_PRODUCT: '/account/products/:productId/',
  DELETE_PRODUCT_IMAGE: '/account/product-images/:imageId/',
  DELETE_PRODUCT_VIDEO: '/account/product-videos/:videoId/',
  CHANGE_PRODUCT_IMAGES_ORDER: '/account/product-images/bulk-update/',
  CHANGE_PRODUCT_VIDEOS_ORDER: '/account/product-videos/bulk-update/',
  ADD_VIDEO_TO_PRODUCT: '/account/product-videos/',
  ADD_IMAGE_TO_PRODUCT: '/account/product-images/',
  GET_PRODUCT_OVERVIEW: '/account/product-overview/',
  REPORT_ISSUE: '/account/retailer-product-reports/',
  ADD_TO_FAVORITE: '/account/products/:productId/add-to-favorite/',
  REMOVE_FROM_FAVORITE: '/account/products/:productId/remove-from-favorite/',
  GET_PRODUCT_TAGS: '/product-tags/',
  ADD_TAG_TO_PRODUCT: '/account/products/:productId/add-tags/',
  REMOVE_TAG_FROM_PRODUCT: '/account/products/:productId/remove-tags/',
}
